const renderMilestoneItems = (items, startIndex = 0) => (
  <div className="milestone-track milestone-track-split" data-testid={`milestone-track-${startIndex + 1}`}>
    {items.map((item, index) => {
      const itemIndex = startIndex + index;
      return (
        <article className="milestone-item" key={`${item.year}-${item.title}`} data-testid={`milestone-item-${itemIndex + 1}`}>
          <span data-testid={`milestone-year-${itemIndex + 1}`}>{item.year}</span>
          <h3 data-testid={`milestone-title-${itemIndex + 1}`}>{item.title}</h3>
          <p data-testid={`milestone-text-${itemIndex + 1}`}>{item.text}</p>
        </article>
      );
    })}
  </div>
);

export function Milestones({ content, brand, images = [] }) {
  const firstMilestones = (content.items || []).slice(0, 2);
  const laterMilestones = (content.items || []).slice(2);

  return (
    <>
      <section id="milestones" className="section milestones-section milestones-intro-section" data-testid="milestones-section">
        <div className="slide-split">
          <div className="section-heading wide">
            <p className="overline" data-testid="milestones-overline">{content.overline}</p>
            <h2 data-testid="milestones-title">{content.title}</h2>
            <p data-testid="milestones-description">{content.description}</p>
          </div>
          <div className="deck-image-panel milestone-visual-panel" data-testid="milestones-image-panel-1">
            {images[0]?.image ? <img src={images[0].image} alt={content.title} data-testid="milestones-image-1" /> : (
              <div className="technical-panel-content" data-testid="milestones-visual-content-1">
                <span>{content.items?.[0]?.year || content.overline}</span>
                <strong>{brand || content.items?.[0]?.title}</strong>
                <p>{content.items?.[1]?.title}</p>
              </div>
            )}
          </div>
        </div>

        {renderMilestoneItems(firstMilestones, 0)}
      </section>

      <section className="section milestones-section milestones-detail-section" data-testid="milestones-detail-section">
        <div className="slide-split">
          <div className="section-heading wide compact-heading">
            <p className="overline" data-testid="milestones-detail-overline">{content.overline}</p>
            <h2 data-testid="milestones-detail-title">
              {[laterMilestones[0]?.year, laterMilestones[1]?.year].filter(Boolean).join(" / ") || content.title}
            </h2>
          </div>
          <div className="deck-image-panel milestone-visual-panel" data-testid="milestones-image-panel-2">
            {images[1]?.image ? <img src={images[1].image} alt={content.overline} data-testid="milestones-image-2" /> : (
              <div className="technical-panel-content" data-testid="milestones-visual-content-2">
                <span>{laterMilestones[0]?.year || content.overline}</span>
                <strong>{laterMilestones[0]?.title}</strong>
                <p>{laterMilestones[1]?.title}</p>
              </div>
            )}
          </div>
        </div>

        {renderMilestoneItems(laterMilestones, 2)}
      </section>
    </>
  );
}